module.exports = __webpack_public_path__ + "img/f0389f45f3988bd8feade9344b7e67f2.png";